export default "__VITE_ASSET__Dh53y5QA__"